export default __webpack_public_path__ + "fc13ba477f71cdfab54b63a93147853f.png";